import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import CreateProviderForm from '@/components/admin/providers/CreateProviderForm';
import ProvidersList from '@/components/admin/providers/ProvidersList';
import { fetchFilteredProviders, setProviderFilter } from '@/features/provider/providerSlice';

const ProvidersManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isCreating, setIsCreating] = React.useState(false);

  // Initialize providers list on component mount
  useEffect(() => {
    // Reset to default filter and fetch providers
    const initialFilter = {
      search: null,
      type: null,
      ownership: null,
      country: 'Tunisia',
      state:null,
      city: null,
      category: null,
      page: 1,
      limit: 10
    };
    
    dispatch(setProviderFilter(initialFilter));
    dispatch(fetchFilteredProviders(initialFilter) as any);
  }, [dispatch]);

  return (
    <div className="container mx-auto py-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Providers Management</h1>
        {!isCreating && (
          <Button onClick={() => setIsCreating(true)}>
            <Plus className="mr-2 h-4 w-4" />
            Add Provider
          </Button>
        )}
      </div>

      {isCreating ? (
        <div className="mt-6">
          <CreateProviderForm />
          <div className="mt-4 text-center">
            <Button variant="outline" onClick={() => setIsCreating(false)}>
              Cancel
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <ProvidersList />
        </div>
      )}
    </div>
  );
};

export default ProvidersManagement;